module.exports = __webpack_public_path__ + "img/zmcw.1fc1af96.png";